import { Stack } from "@mui/material";
import LegendBullet from "components/chart/LegendBullet";
import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { EnergyAnalysisCategoryTotal } from "../model/types";

type EnergyAnalysisShareLegendProps = {
  items: EnergyAnalysisCategoryTotal[];
  unit: string;
};

export const EnergyAnalysisShareLegend = ({ items, unit }: EnergyAnalysisShareLegendProps) => {
  return (
    <Stack className="w-full flex-col items-stretch gap-2">
      {items.map((item) => (
        <Stack className="w-full justify-between gap-4" key={item.key}>
          <Stack className="gap-2">
            <LegendBullet color={item.color} height="0.8rem" type="circle" width="0.8rem" />
            <span className="font-ds-body-semibold-sm text-lds-foreground-primary">{item.label}</span>
          </Stack>
          <Stack className="gap-6">
            <span className="font-ds-number-regular-sm text-lds-foreground-muted">
              {formatNumberBasedOnUser(item.share * 100, 2)}%
            </span>
            <span className="font-ds-number-regular-sm text-lds-foreground-muted">
              {formatNumberBasedOnUser(item.value, 2)} {unit}
            </span>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
